/*
 *  Author: DL
 *  Date: 2020-12-07 15:00:11
 *  Email: dunaliang@fengmap.com
 *  LastEditTime: 2020-12-18 11:00:46
 *  LastEditors: DL
 *  Description:
 *  Copyright: Copyright 2014 - 2020, FengMap, Ltd. All rights reserved.
 */

export default {
    namespace: 'map',
    state: {
        listGroups: [], //当前地图楼层信息
        focusGroupId: 1, //当前聚焦楼层
        visibleGroupIDs: [1],
        focusModel: {}, //当前聚焦模型
        current: {}, //当前定位点
        coords: {
            // start: { FID: '', x: 12957664, y: 4861903, groupID: 1, name: '我的位置', floor: 'F14', type: 'simulation' },
            // end: { FID: '5748681401489', name: '设备间', groupID: 1, x: 12957656.463354599, y: 4861892.86737143, floor: 'F14' },
        }, //起终点坐标点
    },
    reducers: {
        changeState(state, { payload: { field, value } }) {
            return {
                ...state,
                [`${field}`]: value,
            };
        },
        updateListGroups(state, { payload: { listGroups } }) {
            return {
                ...state,
                listGroups,
            };
        },
        updateFocusGroupId(state, { payload: { focusGroupId } }) {
            return {
                ...state,
                focusGroupId,
            };
        },
        updateFocusModel(state, { payload: { focusModel } }) {
            return {
                ...state,
                focusModel,
            };
        },
        updateCoordField(state, { payload: { field, model } }) {
            return {
                ...state,
                coords: {
                    ...state.coords,
                    [`${field}`]: model,
                },
            };
        },
        updateCoords(state, { payload: { coords } }) {
            return {
                ...state,
                coords,
            };
        },
        updateCurrent(state, { payload: { current } }) {
            return {
                ...state,
                current,
            };
        },
        updatevisibleGroupIDs(state, { payload: { visibleGroupIDs } }) {
            return {
                ...state,
                visibleGroupIDs,
            };
        },
    },
    effects: {},
    subscriptions: {},
};
